import { create } from "zustand";
import { api } from "@/lib/api";

interface User {
  id: string;
  email: string;
  name: string;
  role: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  setToken: (token: string) => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  token: localStorage.getItem("bazaar_token"),
  loading: false,

  login: async (email: string, password: string) => {
    set({ loading: true });
    try {
      const res = await api.post<{ token: string; user: User }>(
        "/auth/login",
        { email, password },
      );
      localStorage.setItem("bazaar_token", res.token);
      set({ token: res.token, user: res.user, loading: false });
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  logout: () => {
    localStorage.removeItem("bazaar_token");
    set({ token: null, user: null });
  },

  setToken: (token: string) => {
    localStorage.setItem("bazaar_token", token);
    set({ token });
  },
}));
